import script from "./NavAltMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavAltMenu.vue?vue&type=script&setup=true&lang=ts"

import "./NavAltMenu.vue?vue&type=style&index=0&id=7a1cbaf6&lang=css"

const __exports__ = script;

export default __exports__